export const isIdLoading = (id: string) => id.startsWith('loading-');
